export default class Item {
	/**
	 * Item indentifier code or UPC/EAN
	 */
	code?: string = undefined;

	/**
	 * Item product title
	 */
	title?: string = undefined;

	/**
	 * Item per unit price
	 */
	price?: number = undefined;

	/**
	 * Item quantity
	 */
	qty?: number = undefined;

	/**
	 * Item tax amount per unit
	 */
	tax?: number = undefined;

	/**
	 * Item total value
	 */
	total?: number = undefined;

	/**
	 * Initialize model
	 */
	constructor() {
		this.price = 0.00;
		this.qty = 1;
		this.tax = 0.00;
		this.total = 0.00;
	}

	/**
	 * Totalize item price by quantity
	 * @return
	 */
	totalize() {
		if (this.price === undefined || this.qty === undefined) {
			return this;
		}

		this.total = this.price * this.qty;

		return this;
	}
}
